import { formatDistance } from './formatDistance'

export const locale = () => ({
  formatDistance,
})
